function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 45H8V3h22l10 10z",
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13H30V3Z",
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.17-14.661 9-9 31 31-9 9z",
    style: {
      fill: "#42a5f5"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.345-11.481-1.414-1.414 4.5-4.5 1.414 1.414zm17.148 8.144 1.414 1.414-2.5 2.5-1.414-1.414zm-17.03-17.031 1.413 1.414-2.5 2.5-1.414-1.414zM85.52 2.691l1.418 1.414-2.504 2.5-1.414-1.414zM68.462-14.368l1.414 1.414-2.5 2.5-1.414-1.414zm9.531 18.531 4.5-4.5 1.414 1.414-4.5 4.5z",
    style: {
      fill: "#1565c0"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.751-18.595-3.648-3.648a1.422 1.422 0 0 0-2.016 0l-1.719 1.719 5.664 5.664 1.72-1.719a1.422 1.422 0 0 0 0-2.016",
    style: {
      fill: "#e57373"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.075 7.765 25.461-25.461 5.664 5.668-25.46 25.46z",
    style: {
      fill: "#ff9800"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.032-14.861 84.2-12.028l-5.668-5.66 2.832-2.836z",
    style: {
      fill: "#b0bec5"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.075 7.769-1.906 7.57 7.57-1.906z",
    style: {
      fill: "#ffc107"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.134 11.511-.965 3.828 3.828-.965z",
    style: {
      fill: "#37474f"
    },
    transform: "matrix(.55 0 0 .55 -15.104 29.334)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateFile);
export default __webpack_public_path__ + "static/media/templateFile.7630b579b2de45d14d963d3a9b74c3be.svg";
export { ForwardRef as ReactComponent };